module.exports = __webpack_public_path__ + "img/일광역.8bf6cc21.webp";